export const DATA_TABLE_TEST_ID = 'data-table';
export const CELL_KEY = 'cell';
export const HEAD_CELL_KEY = 'head-cell';
export const ROW_KEY = 'row';
